export const selectOrgDetailsOrganization = (
  /** @type {import("./index").StoreState}} */ state
) => state?.persistedDataReducer?.orgDetails?.organization;

export const selectNewLiveService = (
  /** @type {import("./index").StoreState}} */ state
) => selectOrgDetailsOrganization(state)?.newLiveServiceEnabled;
export const selectMmServiceEnabledOnCourses = (state) =>{
  return state?.persistedDataReducer?.orgDetails?.organization?.mmServiceEnabledOnCourses;
};

// export const selectDefaultLanguageFromOrgDetails = (
//   /** @type {import("./index").StoreState}} */ state
// ) => selectOrgDetailsOrganization(state)?.defaultLanguage;
